import React, { useEffect } from "react";
import { UserManager } from "oidc-client-ts";

export const SilentRenew: React.FC = () => {
  useEffect(() => {
    // Get environment configuration
    const getEnvironment = () => ({
      CLIENT_SCOPE: window?._env_?.REACT_APP_AUTH_CLIENT_SCOPE || 
        import.meta.env.REACT_APP_AUTH_CLIENT_SCOPE || "openid profile email",
      CLIENT_ID: window?._env_?.REACT_APP_AUTH_CLIENT_ID || 
        import.meta.env.REACT_APP_AUTH_CLIENT_ID!,
      CLIENT_ROOT: window?._env_?.REACT_APP_AUTH_CLIENT_ROOT || 
        import.meta.env.REACT_APP_AUTH_CLIENT_ROOT || window.location.origin,
      STS_AUTHORITY: window?._env_?.REACT_APP_STS_AUTHORITY || 
        import.meta.env.REACT_APP_STS_AUTHORITY!,
    });

    const env = getEnvironment();

    // Create UserManager with matching configuration
    const userManager = new UserManager({
      authority: env.STS_AUTHORITY,
      client_id: env.CLIENT_ID,
      redirect_uri: `${env.CLIENT_ROOT}/signin-callback`,
      response_type: "code",
      scope: env.CLIENT_SCOPE,
    });

    // Handle the silent renew callback
    userManager.signinSilentCallback()
      .then((_user) => {
        console.log('[SilentRenew] Silent renew successful');
      })
      .catch((error) => {
        console.error('[SilentRenew] Silent renew error:', error);
      });
  }, []);

  // This component is loaded in an iframe for silent token renewal
  // It doesn't need to render anything visible
  return <div style={{ display: 'none' }}>Silent token renewal...</div>;
};

export default SilentRenew;
